/** @format */

import { DOCUMENT } from '@angular/common';
import { Component, Inject, ViewChild, OnInit, OnDestroy, Renderer2 } from '@angular/core';

import { HmfModalComponent } from '@dsg-tech/homefield-angular';
import { interval, Subject, takeUntil } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { UtilityService } from '@shared/utils/services';
import { KillswitchService } from '@shared/data-access/services';
import { chain } from 'chains/chain';
import { Store } from '@ngrx/store';
import { closeReviewImageModal } from '@product-reviews/data-access';

@Component({
	selector: 'product-reviews-modal',
	templateUrl: './review-modal.component.html',
	styleUrl: './review-modal.component.scss',
	standalone: false
})
export class ReviewModalComponent implements OnInit, OnDestroy {
	public hasNewReviewsEnhancement = false;
	private previousFocusedElement: Element;
	private UNSUBSCRIBE$ = new Subject<void>();

	@ViewChild(HmfModalComponent) hmfModalComponent: HmfModalComponent | undefined;

	constructor(
		@Inject(DOCUMENT) private document: Document,
		private killSwitchService: KillswitchService,
		private utilityService: UtilityService,
		private store: Store,
		private renderer: Renderer2
	) {}

	ngOnInit(): void {
		this.handleKillSwitch();
	}

	ngOnDestroy(): void {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}

	openModal() {
		//TODO: fix in homefield and remove
		this.previousFocusedElement = this.document.activeElement;
		this.hmfModalComponent?.openModal();
		this.renderer.addClass(this.document.body, 'hmf-modal-open');

		//TODO: workaound to focus inside modal => fix in homefield and remove
		interval(300)
			.pipe(
				map(() => {
					if (this.hmfModalComponent?.modalContainer) {
						this.handleFocusFirstElement();
					}

					return !!this.hmfModalComponent?.modalContainer;
				}),
				filter(Boolean),
				take(1)
			)
			.subscribe();
	}

	closeModalEvt() {
		this.store.dispatch(closeReviewImageModal());
		this.restoreFocus();
		this.renderer.removeClass(this.document.body, 'hmf-modal-open');
	}

	onKeydownEvent(event: KeyboardEvent) {
		const closeButton = this.document.getElementsByClassName('hmf-modal-container-close');

		if (
			event.key === 'Enter' &&
			closeButton &&
			Array.from(closeButton).find((els) => els == this.document.activeElement)
		) {
			this.hmfModalComponent?.closeModal();
		}
	}

	//TODO: workaound to focus previous element => fix in homefield and remove
	restoreFocus() {
		(this.previousFocusedElement as HTMLElement).focus();
	}

	//TODO: fix in homefield and remove
	handleFocusFirstElement() {
		const focusElement =
			this.hmfModalComponent?.modalContainer?.nativeElement?.querySelectorAll(
				'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
			)[0] as HTMLElement;

		if (focusElement) {
			const x = window.scrollX;
			const y = window.scrollY;
			focusElement.focus();
			window.scrollTo(x, y);
		}
	}

	handleKillSwitch(): void {
		this.killSwitchService
			.getKillSwitchesEnvironment$()
			.pipe(
				takeUntil(this.UNSUBSCRIBE$),
				map((data) =>
					this.utilityService.checkKillSwitch(
						'newReviewsEnhancement',
						data,
						chain.chainIdentifierAbbr
					)
				)
			)
			.subscribe((hasNewReviewsEnhancement) => {
				this.hasNewReviewsEnhancement = hasNewReviewsEnhancement;
			});
	}
}
